import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import { TRFPUsersData, TRFPUsersRequest } from './types'
import { ResponseWithPagination } from '../../../constants'

const fetcher = new Fetcher({})

export const getAssignedCoUsers = async ({ id, data }) =>
  fetcher.request<TRFPUsersRequest, ResponseWithPagination<TRFPUsersData>>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITY_USERS}${API_DICTIONARY.CO_USERS}`,
    method: HTTP_METHODS.GET,
    ...data
  })
export const getAssignedVendorsUsers = async ({ id, data }) =>
  fetcher.request<TRFPUsersRequest, ResponseWithPagination<TRFPUsersData>>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITY_USERS}${API_DICTIONARY.VENDOR_USERS}`,
    method: HTTP_METHODS.GET,
    ...data
  })
